import { render, staticRenderFns } from "./SpcmMilestonesAdd.vue?vue&type=template&id=f2d3bb9c&scoped=true"
import script from "./SpcmMilestonesAdd.vue?vue&type=script&lang=js"
export * from "./SpcmMilestonesAdd.vue?vue&type=script&lang=js"
import style0 from "./SpcmMilestonesAdd.vue?vue&type=style&index=0&id=f2d3bb9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2d3bb9c",
  null
  
)

export default component.exports